import * as React from "react";
const SvgIcFindLocationFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22 2L14 22L9.9375 14.0625L2 10L22 2Z" fill="currentColor" /></svg>;
export default SvgIcFindLocationFilled;